import { useNavigate } from 'react-router-dom';
import Button from '../../../components/Assets/Button';
import SectionTitle from '../../../components/Assets/sectionTitle';

const FoldersHeader = () => {
  const navigate = useNavigate();

  return (
    <header className="my-folders-header">
      <SectionTitle
        mainTitle="Dossier de prospection"
        subTitle="Organisez et optimisez votre prospection"
      />
      <div>
        <Button
          btnType="button"
          btnContent="CREER UN DOSSIER"
          handleClick={() => navigate('/mes-dossiers-creation')}
          primary
        />
      </div>
    </header>
  );
};

export default FoldersHeader;
